import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

const AgGridContainer = styled(Box)(({theme}) => ({
    flexGrow: 1,
    marginTop: '10px',
    backgroundColor: 'white',
}))

export default AgGridContainer;